import { IConfigRepository } from '@/modules/config/core/config.repository.interface'
import { ConfigResponseDto } from '@/modules/config/core/config.types'

export class ConfigService {
  constructor(private configRepository: IConfigRepository) {}

  async getAll(): Promise<ConfigResponseDto> {
    return this.configRepository.getAll()
  }
}
